import { Link } from '@tanstack/react-router';

/** Kleine Impressum/Datenschutz-Links — Pflichtangaben (§ 5 DDG bzw. Art. 13
 * DSGVO) müssen von jeder Seite aus in maximal zwei Klicks erreichbar sein.
 * Bewusst unauffällig (wie der darunterstehende Build-Link in der Sidebar),
 * aber immer sichtbar, nicht erst hinter einem Menü versteckt. */
export function LegalLinks({ className = '' }: { className?: string }) {
  return (
    <div className={`flex items-center justify-center gap-2 text-xs text-slate-400 ${className}`}>
      <Link to="/impressum" className="hover:text-slate-600 hover:underline">
        Impressum
      </Link>
      <span aria-hidden="true">·</span>
      <Link to="/datenschutz" className="hover:text-slate-600 hover:underline">
        Datenschutz
      </Link>
    </div>
  );
}
